import { Stack } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { spacing as spacing$1, alpha } from '@mui/system';
import { switchProp } from 'styled-tools';
import { shouldNotForwardProps, spacing, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16;
const Card = styled(Stack, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  padding: ${0};

  ${0};

  border-radius: 12px;

  ${0}

  ${0}

  ${0}

  ${0}

  ${0};
`), switchProp('size', {
  small: spacing(4),
  normal: spacing(6)
}), spacing$1, withUtility(({}, {
  maxWidth
}) => {
  if (maxWidth) {
    return css(_t2 || (_t2 = _`
        max-width: ${0};
      `), maxWidth);
  }
  return css(_t3 || (_t3 = _``));
}), withUtility(({}, {
  fullWidth
}) => {
  if (fullWidth) {
    return css(_t4 || (_t4 = _`
        width: 100%;
      `));
  }
  return css(_t5 || (_t5 = _``));
}), withUtility(({}, {
  fullHeight
}) => {
  if (fullHeight) {
    return css(_t6 || (_t6 = _`
        height: 100%;
      `));
  }
  return css(_t7 || (_t7 = _``));
}), withUtility(({}, {
  onClick,
  disabled
}) => {
  if (onClick && !disabled) {
    return css(_t8 || (_t8 = _`
        cursor: pointer;
      `));
  }
  return css(_t9 || (_t9 = _``));
}), withUtility(({
  palette,
  isLight
}, {
  variant,
  disabled,
  selected,
  hasHover
}) => {
  switch (true) {
    case variant === 'filled':
      {
        if (disabled) {
          return css(_t10 || (_t10 = _`
            cursor: not-allowed;
            background-color: ${0};
          `), alpha(palette('onSurface'), 0.12));
        }
        if (selected) {
          return css(_t11 || (_t11 = _`
            background-color: ${0};
          `), palette('surfaceVariant'));
        }
        return css(_t12 || (_t12 = _`
          background-color: ${0};

          ${0}
        `), isLight ? alpha(palette('primary'), 0.05) : palette('surface'), hasHover && `&:hover {
              background-color: ${alpha(palette('primary'), 0.08)};
            }`);
      }
    case variant === 'outlined':
      {
        if (disabled) {
          return css(_t13 || (_t13 = _`
            cursor: not-allowed;
            background-color: ${0};
            border: 1.5px solid ${0};
          `), alpha(palette('onSurface'), 0.12), alpha(palette('onSurface'), 0.12));
        }
        if (selected) {
          return css(_t14 || (_t14 = _`
            background-color: ${0};
            border: 1.5px solid ${0};
          `), palette('surfaceVariant'), palette('primary'));
        }
        return css(_t15 || (_t15 = _`
          border: 1px solid ${0};

          ${0}
        `), palette('surfaceVariant'), hasHover && `&:hover {
            border: 1.5px solid ${alpha(palette('primary'), 1)};
            background-color: ${alpha(palette('primary'), 0.08)};
          }`);
      }
    default:
      return css(_t16 || (_t16 = _``));
  }
}));
Card.defaultProps = {
  hasHover: true,
  fullWidth: true,
  fullHeight: false,
  size: 'normal'
};

export { Card };
